import React, { useState } from 'react';
import VideoWithPlayCountInput from './VideoWithPlayCountInput';
import styles from './VideoWithPlayCountAndRadioOptionsInput.module.scss';
import { joinClasses } from '../../../Utils/className.util';
import Button from '../../BaseModule/Components/Button';

interface Option {
	id: string;
	title: string;
	value: string;
	score: number;
}

interface Props {
	video: string;
	playcountName: string;
	answerName: string;
	scoreName: string;
	options: Option[];
	playDelayInSeconds?: number;
	maxPlays?: number;
	playRequired?: boolean;
	required?: boolean;
	playcountNetteRules?: any;
	answerNetteRules?: any;
	scoreNetteRules?: any;
}

const VideoWithPlayCountAndRadioOptionsInput: React.FC<Props> = ({
	video,
	playcountName,
	answerName,
	scoreName,
	playcountNetteRules,
	answerNetteRules,
	scoreNetteRules,
	playDelayInSeconds = 0,
	maxPlays = 999,
	playRequired = true,
	required = true,
	options,
}) => {
	const [isVideoPlayed, setIsVideoPlayed] = useState<boolean>(false);
	const [selectedOption, setSelectedOption] = useState<Option | undefined>(
		undefined,
	);

	const handleSubmit = () => {
		document.getElementById('questionnaire-hidden-submit')?.click();
	};

	return (
		<div>
			<VideoWithPlayCountInput
				video={video}
				name={playcountName}
				netteRules={playcountNetteRules}
				playDelayInSeconds={playDelayInSeconds}
				maxPlays={maxPlays}
				playRequired={playRequired}
				onVideoPlayed={() => setIsVideoPlayed(true)}
				onVideoPlay={() => setIsVideoPlayed(false)}
			/>
			{isVideoPlayed && (
				<>
					<div className={styles.options}>
						{options.map(option => {
							return (
								<div
									className={joinClasses([
										styles.option,
										option.id === selectedOption?.id ? styles.active : '',
									])}
									onClick={() => setSelectedOption(option)}
								>
									{option.title}
								</div>
							);
						})}
					</div>
					<Button onClick={handleSubmit} text='OK' />
				</>
			)}
			<input
				type='text'
				style={{ display: 'none' }}
				value={selectedOption?.title}
				name={answerName}
				required={required}
				data-nette-rules={answerNetteRules}
				readOnly
			/>
			<input
				type='number'
				style={{ display: 'none' }}
				value={selectedOption?.score}
				name={scoreName}
				required={required}
				data-nette-rules={scoreNetteRules}
				readOnly
			/>
		</div>
	);
};

export default VideoWithPlayCountAndRadioOptionsInput;
